import React, {Component} from "react";
import TitlePage from "./TitlePageView";

export default class TitlePageContainer extends Component {
    render() {
        return <TitlePage title={this.props.title} menuIcon={this.props.menuIcon}/>

    }
};